import React from "react";

export default function UserDetails({ email, system, ip, location }) {
  return (
    <div className="user-details-container">
      {email && (
        <div className="user-detail-item">
          <div className="user-detail-icon">
            <i className="mdi mdi-email"></i>
          </div>
          <div className="user-detail-content">
            <div className="user-detail-label">Email</div>
            <div className="user-detail-value">{email}</div>
          </div>
        </div>
      )}

      {location && (
        <div className="user-detail-item">
          <div className="user-detail-icon">
            <i className="mdi mdi-map-marker"></i>
          </div>
          <div className="user-detail-content">
            <div className="user-detail-label">Location</div>
            <div className="user-detail-value">{location}</div>
          </div>
        </div>
      )}

      {system && (
        <div className="user-detail-item">
          <div className="user-detail-icon">
            <i className="mdi mdi-desktop-classic"></i>
          </div>
          <div className="user-detail-content">
            <div className="user-detail-label">System</div>
            <div className="user-detail-value">{system}</div>
          </div>
        </div>
      )}

      {ip && (
        <div className="user-detail-item">
          <div className="user-detail-icon">
            <i className="mdi mdi-ip"></i>
          </div>
          <div className="user-detail-content">
            <div className="user-detail-label">IP Address</div>
            <div className="user-detail-value">{ip}</div>
          </div>
        </div>
      )}
    </div>
  );
}